/** Mirrors backend rulebook: Current Bet Level drives blind (1×/2×) and chaal (2×/4×) amounts */

import type { BetTiersView } from 'types/game';

export function blindBetOptions(currentStake: number): [number, number] {
  const level = Math.max(1, currentStake);
  return [level, level * 2];
}

export function chaalBetOptions(currentStake: number): [number, number] {
  const level = Math.max(1, currentStake);
  return [level * 2, level * 4];
}

export function capChaalOptions(currentStake: number, maxBet?: number): [number, number] {
  let [low, high] = chaalBetOptions(currentStake);
  if (maxBet != null && maxBet > 0) {
    low = Math.min(low, maxBet);
    high = Math.min(high, maxBet);
  }
  if (low > high) return [high, high];
  return [low, high];
}

export function showBetCost(currentStake: number, isSeen: boolean): number {
  const level = Math.max(1, currentStake);
  return isSeen ? level * 2 : level;
}

/** Client-side bet tiers for the viewing player (shown on buttons even when waiting). */
export function resolveViewerBetTiers(
  isSeen: boolean,
  currentStake: number,
  options?: { maxBet?: number; includeBlind?: boolean }
): BetTiersView {
  const level = Math.max(1, currentStake);
  const out: BetTiersView = {
    show: showBetCost(level, isSeen),
  };

  if (!isSeen && options?.includeBlind !== false) {
    out.blind = blindBetOptions(level);
  }
  if (isSeen) {
    out.chaal = capChaalOptions(level, options?.maxBet);
  }

  return out;
}
